var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styles from './VerifyWithHeadsup.css';
import { OtpStrongAuth } from './src/OtpStrongAuth';
import Button from 'fk-cp-common-components/webComponents/V4/common/Button';
import ApiCallerInterface from '@utils/ApiCallerInterface';
import { fkPay } from './src/Utils/SMSHelper';
import { formatMessage } from '@utils/i18n';
import withDrawer from '@common/Drawer/v2/withDrawer';
import withSnackbar from '@common/Snackbar/withSnackbar';
import withDialog from '@common/Dialog/withDialog';
var apiHelper = function (pathname) { return function (_a, body) {
    var apiCaller = _a.apiCaller, config = _a.config, method = _a.method;
    return apiCaller[method](__assign(__assign({}, config), { pathname: pathname }), body);
}; };
var TwoFactorAuth = /** @class */ (function (_super) {
    __extends(TwoFactorAuth, _super);
    function TwoFactorAuth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOtpAutoFilled: false,
            params: {},
            showOTP: false,
            showButtonLoader: false,
            error: '',
            errorMessage: '',
            RESPONSE: {},
            isSMSAutoCapturePossible: false
        };
        _this.generateOtpSuccess = function (params) {
            _this.setState(__assign(__assign({}, params), { showOTP: true }));
        };
        _this.generateOtpError = function (response) {
            var _a, _b;
            var params = ((_b = (_a = response) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.body) || {};
            var errorMessage = params.message || params.serverErrorMessage;
            _this.setState({
                error: true,
                errorMessage: errorMessage
            });
            _this.openWidget();
            _this.props.showSnackbar({
                infoText: errorMessage // error
            });
        };
        _this.generateOtp = function (newStateProps) {
            fkPay.getSMSReceivePermission(function () {
                _this.setState(__assign(__assign({}, newStateProps), { isSMSAutoCapturePossible: fkPay.isAutocapturePossible() }));
                var body = {
                    flowType: 'TWO_FACTOR_AUTHENTICATION'
                };
                ApiCallerInterface('post', {}, apiHelper('/api/8/user/otp/generate'), body)
                    .then(_this.generateOtpSuccess)
                    .catch(_this.generateOtpError);
            });
        };
        _this.validateOtpSuccess = function () {
            _this.props.onSuccess();
            _this.openWidget();
        };
        _this.validateOtpError = function (response) {
            var _a, _b, _c, _d;
            var params = ((_b = (_a = response) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.body) || {};
            var errorMessage = ((_d = (_c = params) === null || _c === void 0 ? void 0 : _c.RESPONSE) === null || _d === void 0 ? void 0 : _d.message) || formatMessage({ id: 'errorMsg1' });
            _this.setState({
                error: errorMessage,
                showButtonLoader: false
            });
            _this.props.showSnackbar({
                infoText: errorMessage // error
            });
        };
        _this.validateOtp = function () {
            var _a = _this.state, otpIdentifierInfo = _a.RESPONSE.otpIdentifierInfo, otp = _a.params.otp;
            if (otpIdentifierInfo.length > 0) {
                var body = {
                    userId: otpIdentifierInfo[0].userId,
                    requestId: otpIdentifierInfo[0].requestId,
                    otp: otp
                };
                ApiCallerInterface('post', {}, apiHelper('/api/1/user/otp/2fa/validate'), body)
                    .then(_this.validateOtpSuccess)
                    .catch(_this.validateOtpError);
            }
        };
        _this.verifyOtp = function (otp) {
            _this.setState({
                showButtonLoader: true,
                error: false,
                errorMessage: '',
                params: { otp: otp }
            }, _this.validateOtp);
        };
        _this.otpAutoFilled = function (otp) {
            /**
             * if auto capture successfully happened, set a flag so that
             * it could be used for differentiating auto detect and manually entered otp
             */
            if (otp) {
                _this.setState({
                    isOtpAutoFilled: true
                });
            }
        };
        _this.resendOtp = function () {
            _this.generateOtp({
                error: false,
                errorMessage: ''
            });
        };
        _this.openOTPFlowDrawer = function () {
            _this.generateOtp({
                showOTP: false
            });
            _this.showOtpWorkflowDrawer();
        };
        _this.showHeadsUpDrawer = function () {
            if (_this.props.isDialog) {
                _this.props.openDialog({
                    actions: {
                        buttons: [
                            {
                                text: formatMessage({ id: 'proceed' }),
                                onClick: _this.openOTPFlowDrawer
                            },
                        ]
                    },
                    children: (<div className={styles['headsUpDrawerContainer']}>
						<div className={styles['headsUpDrawerHeading']}>
							{formatMessage({ id: 'verificationRequired' })}
						</div>
						<div className={styles['headsUpDrawerText']}>{formatMessage({ id: 'verificationDetails' })}</div>
					</div>),
                    zIndex: 1010,
                    buttonClass: styles['buttonClassHeadsUp'],
                    onClose: _this.props.onClose,
                    noHashRequired: true,
                    customButtonStyle: true
                });
            }
            else {
                _this.props.openDrawer({
                    children: (<div className={styles['headsUpDrawerContainer']}>
							<div className={styles['headsUpDrawerHeading']}>
								{formatMessage({ id: 'verificationRequired' })}
							</div>
							<div className={styles['headsUpDrawerText']}>{formatMessage({ id: 'verificationDetails' })}</div>
							<Button disabled={false} onClick={_this.openOTPFlowDrawer} className={styles['headsUpDrawerButton']}>
								{formatMessage({ id: 'proceed' })}
							</Button>
						</div>),
                    onClose: _this.props.onClose
                });
            }
        };
        _this.showOtpWorkflowDrawer = function () {
            var _a, _b, _c;
            var _d = _this.state, showOTP = _d.showOTP, showButtonLoader = _d.showButtonLoader, error = _d.error, errorMessage = _d.errorMessage, RESPONSE = _d.RESPONSE, isSMSAutoCapturePossible = _d.isSMSAutoCapturePossible;
            var children = (<OtpStrongAuth key="" shouldAutoFocus={false} isIosInput={false} isOtpOverlayVisible={showOTP} hideOtpOverlay={_this.props.onClose} sentTo={(_c = (_b = (_a = RESPONSE) === null || _a === void 0 ? void 0 : _a.otpIdentifierInfo) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.userId} autoCaptureText={formatMessage({ id: 'autoCaptureText' })} numInputs={6} mode="" resendText={formatMessage({ id: 'resendOtp' })} didntGetOtpText={formatMessage({ id: 'noOtp' })} buttonText={formatMessage({ id: 'verify' })} showButtonLoader={showButtonLoader} error={error} errorMessage={errorMessage} verifyOtpCallback={_this.verifyOtp} resendOtpCallback={_this.resendOtp} autoCaptureSuccessCallback={_this.otpAutoFilled} isSMSAutoCapturePossible={isSMSAutoCapturePossible}/>);
            if (_this.props.isDialog) {
                _this.props.openDialog({
                    children: children,
                    zIndex: 1010,
                    onClose: _this.props.onClose,
                    noHashRequired: true
                });
            }
            else {
                _this.props.openDrawer({
                    children: children,
                    onClose: _this.props.onClose
                });
            }
        };
        return _this;
    }
    TwoFactorAuth.prototype.openWidget = function () {
        if (this.props.isDialog) {
            this.props.closeDialog();
        }
        else {
            this.props.closeDrawer();
        }
    };
    TwoFactorAuth.prototype.componentDidMount = function () {
        this.showHeadsUpDrawer();
    };
    TwoFactorAuth.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState !== this.state) {
            this.showOtpWorkflowDrawer();
        }
    };
    TwoFactorAuth.prototype.componentWillUnmount = function () {
        this.openWidget();
    };
    TwoFactorAuth.prototype.render = function () {
        return <React.Fragment />;
    };
    return TwoFactorAuth;
}(React.Component));
export default withSnackbar(withDialog(withDrawer(TwoFactorAuth)));
